import React from 'react';
import ExternalLink from '~/components/ExternalLink';
import { DarkModeToggle } from '~/pages/layout/DarkModeToggle';
import { getAppContext } from '~/lib/AppContext';
import './PreLoginPanel.scss';
import { Card, CardBody } from 'reactstrap';

interface PreLoginPanelProps {
    children: React.ReactNode;
}

export default class PreLoginPanel extends React.Component<PreLoginPanelProps> {
    render() {
        const appConfig = getAppContext().config;

        return (
            <div className="preLoginPanel">
                <div className="preLoginContainer">
                    <div className="preLoginHeader">
                        <div className="themeToggle">
                            <DarkModeToggle />
                        </div>
                        <div className="logo">
                            <a href={appConfig.wwwSite} title={`Go to ${appConfig.brandName} main site`}>
                                <img src={`/img/logo-${appConfig.theme.toLowerCase()}.png`} alt={appConfig.brandName} />
                            </a>
                        </div>
                    </div>
                    <Card className="preLoginCard">
                        <CardBody>{this.props.children}</CardBody>
                    </Card>

                    <div className="preLoginFooter">
                        <div className="footerLinks">
                            <ExternalLink href={`${appConfig.wwwSite}/legal`}>Legal</ExternalLink>
                            <ExternalLink href={`${appConfig.wwwSite}/security`}>Security</ExternalLink>
                            <ExternalLink href={appConfig.statusSite}>Cloud Status</ExternalLink>
                            <ExternalLink href={appConfig.supportSite}>Help Desk</ExternalLink>
                        </div>
                        <div className="footerBranding">
                            <span>
                                &copy; 2009-{new Date().getFullYear()} {appConfig.companyName}
                            </span>
                            <span className="separator">•</span>
                            <ExternalLink href={appConfig.wwwSite}>{appConfig.brandName}</ExternalLink>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
